<template>
  <footer>
    <div>
      ©Copyright 2018 Hoteliers Dot Guru (Thailand) Co., Ltd
    </div>
  </footer>
</template>

<script>

export default {
  name: 'FooterTemplate',
  components: {}
}
</script>

<style>
  footer {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: #EBEBEB;
    color: #AAAAAA;
    text-align: center;
    padding: 5px 0;
    font-size: 16px;
    font-weight: lighter;
  }
</style>
